import { ActiveTimerResponse } from '../types/dto/active-timer.dto';

export const ACTIVE_TIMER_MAX_SECONDS = 24 * 60 * 60;

export const computeElapsedSeconds = (
  timer: ActiveTimerResponse | null | undefined,
  // Wall-clock timestamp (`Date.now()`) captured when `accumulatedSeconds` was read.
  fetchedAt: number,
  // Wall-clock now (`Date.now()`). Both ends must use the same clock so that after
  // a long tab suspension / OS sleep the delta still equals real elapsed time —
  // a monotonic `performance.now()` delta freezes while suspended and leaves the
  // displayed timer stuck until a refetch (OPS-1538/1534). The server's
  // `accumulatedSeconds` is the source of truth, so this only fills the gap
  // between fetches and self-corrects on the next refetch.
  nowMs: number = Date.now()
): number => {
  if (!timer) return 0;
  if (timer.isPaused) return timer.accumulatedSeconds;
  // accumulatedSeconds is the server's count at fetchedAt; add time elapsed since then
  const liveSec = Math.max(0, Math.floor((nowMs - fetchedAt) / 1000));
  return Math.min(ACTIVE_TIMER_MAX_SECONDS, timer.accumulatedSeconds + liveSec);
};
